import React, { useContext, useEffect, useMemo, useState } from "react";
import Modal from "components/Modals/Modal";

import agent from "server";

export interface ViewScriptModalProps {
  lifecycleScript: string;
  show: boolean;
  setShow: (show: boolean) => void;
  onCancel?: () => void;
  onSuccess?: () => void;
}

export const ViewScriptModal: React.FC<ViewScriptModalProps> = ({
  lifecycleScript,
  show,
  setShow,
  onCancel = () => {},
  onSuccess = () => {},
}) => {
  return (
    <Modal
      isOpen={show}
      setOpen={setShow}
      onClose={() => {
        setShow(false);
      }}
      title={""}
      width={"max-w-7xl"}
      body={
        <div className="flex flex-col">
          <div className="flex flex-row items-center mb-6 text-lg font-bold text-white">
            Lifecycle Script
          </div>
          <pre className="bg-black text-white p-4 rounded overflow-x-auto text-sm whitespace-pre-wrap">
            {lifecycleScript}
          </pre>
        </div>
      }
      confirmLabel="Done"
      hideCancel={true}
      onSuccess={() => {
        setShow(false);
      }}
    />
  );
};
